import * as React from 'react';
/**
 *
 * Original name: Jira
 *
 * Figma URL: https://www.figma.com/file/RPY7Gy4EixfwdOtVIf2PaX/_Global---Icons?node-id=48636%3A420
 *
 */
export const JiraExternalLogo = (props) => (React.createElement("svg", { viewBox: "0 0 24 24", fill: "none", ...props },
    React.createElement("path", { d: "M19.331 4h-7.71a3.48 3.48 0 0 0 3.476 3.476h1.427v1.36A3.48 3.48 0 0 0 20 12.312V4.669A.67.67 0 0 0 19.331 4Z", fill: "currentColor", vectorEffect: "non-scaling-stroke" }),
    React.createElement("path", { d: "M15.52 7.833H7.81a3.48 3.48 0 0 0 3.477 3.476h1.426v1.382a3.48 3.48 0 0 0 3.476 3.476V8.524c0-.38-.312-.691-.668-.691Z", fill: "currentColor", vectorEffect: "non-scaling-stroke" }),
    React.createElement("path", { d: "M4 11.666h7.71c.357 0 .669.312.646.646v7.666A3.48 3.48 0 0 1 8.88 16.5v-1.359H7.476A3.48 3.48 0 0 1 4 11.666Z", fill: "currentColor", vectorEffect: "non-scaling-stroke" })));
